export default "__VITE_ASSET__C5GAw6XH__"